import { selectOrderMapPoints } from '@/features/orders/components/MapPanel/parts/Content/selectors'
import { MapData, VenueMapPoint } from '@/features/orders/components/MapPanel/parts/Content/types'
import { toMapCoordinate } from '@/features/orders/components/MapPanel/parts/Content/utils/toMapCoordinate'
import { useAppSelector } from '@/hooks/redux'
import { licenceSelectors } from '@/redux/reducers/licence'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useLiveMapData = (): MapData => {
    const { t } = useTranslation()
    const licence = useAppSelector(licenceSelectors.licence)
    const orders = useAppSelector(selectOrderMapPoints)

    const lat = licence?.location?.lat
    const lng = licence?.location?.lng
    const label = licence?.name || t('ordersMap.venue')

    const venue = useMemo<VenueMapPoint | undefined>(() => {
        const coordinate = toMapCoordinate({ lat, lng })

        return coordinate ? { id: 'venue', kind: 'venue', coordinate, label } : undefined
    }, [lat, lng, label])

    return useMemo(() => ({ venue, orders }), [venue, orders])
}
